import {Injectable} from '@angular/core';
import {WindowReferenceService} from './window-reference.service';
import {User} from '../user/user';

@Injectable({
  providedIn: 'root'
})

export class LoginEventDatalayerService {
  private window;

  constructor(private windowRef: WindowReferenceService) {
    this.window = windowRef.nativeWindow;
  }

  private DataLayerTrigger(loginEvent) {
    if (loginEvent) {
      this.window.dataLayer.push(loginEvent);
    }
  }

  LoginEvent(userInfo: User) {
    if (userInfo === null) {
      return;
    }
    const mailIdRegex = /\b[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}\b/g;
    const removedMailIdCompanyName = (userInfo.partnerName).replace(mailIdRegex, '');
    let event = {
      event: 'login',
      company_id: userInfo.partnerId,
      company_name: removedMailIdCompanyName,
      configurator_id: 46676,
      configurator_name: 'EcoStruxure PowerBuild Contractors',
      digital_platform_country: userInfo.partnerCountry,
      product_country: userInfo.paceCountry,
      customer_classification_category: userInfo.role,
      customer_classification_sub_category: '',
      is_customer_impersonation: 'false',
      is_federated_id: 'true',
      is_schneider_employee: (userInfo.email).includes('se.com') ? 'true' : 'false',
      is_test_user: '',
      user_id: userInfo.id,
      user_type: userInfo.role
    }
    this.DataLayerTrigger(event);
  }
}
